import { IRootState } from '../../../store'
import { IPatientAllergiesState } from '../store/patientAllergies.types'

export const getPatientAllergiesSelector = (state: IRootState): IPatientAllergiesState => state.patientAllergies
